<script>
import Vue from 'vue';
import store from '../../store'
import ContractManagementList from '../ContractManagementList/ContractManagementList.vue';
import Loading from '../Loading/Loading.vue';
import InfoWidget from '../InfoWidget/InfoWidget.vue';
import {mapState} from 'vuex';

export default Vue.extend({
    components: {
        ContractManagementList,
        InfoWidget,
        Loading
    },
    computed: {
        ...mapState({
            tips: state => state.booking.bookings.tips,
            items: state => state.contract.overview.items,
            listLoading: state => state.contract.overview.loading
        })
    },
    beforeRouteEnter(to, from, next) {
        store.dispatch('contract/getContractYears').then(() => {
            next();
        });

    },
    beforeRouteLeave(to, from, next) {
        Promise.all([
            this.$refs.infoWidget.clean()
        ]).then(() => {
            next();
        });
    }
});
</script>
<template>
    <div class="contract-management-page">
        <loading v-if="listLoading"/>
        <div class="row">
            <div class="col-xs-12">
                <contract-management-list/>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12"/>
        </div>
        <info-widget ref="infoWidget" :tips="tips"/>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/ContractManagementPage/ContractManagementPage.vue